var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuywater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6106 3.05864C15.487 2.93464 15.3401 2.83629 15.1783 2.76925C15.0165 2.70221 14.8431 2.66779 14.668 2.66797H8.0013C7.82619 2.66779 7.65276 2.70221 7.49099 2.76925C7.32922 2.83629 7.18229 2.93464 7.05864 3.05864L3.05864 7.05864C2.93458 7.18224 2.8362 7.32917 2.76915 7.49095C2.7021 7.65273 2.66772 7.82618 2.66797 8.0013V14.668C2.66797 15.0226 2.80797 15.3613 3.05864 15.6106L16.392 28.944C16.5155 29.0682 16.6624 29.1668 16.8242 29.2341C16.9859 29.3014 17.1594 29.336 17.3346 29.336C17.5098 29.336 17.6833 29.3014 17.8451 29.2341C18.0069 29.1668 18.1538 29.0682 18.2773 28.944L28.944 18.2773C29.0679 18.1536 29.1662 18.0066 29.2333 17.8449C29.3004 17.6831 29.3349 17.5097 29.3349 17.3346C29.3349 17.1595 29.3004 16.9861 29.2333 16.8244C29.1662 16.6626 29.0679 16.5157 28.944 16.392L15.6106 3.05864ZM17.3346 26.116L5.33464 14.116V8.5533L8.5533 5.33464H14.116L26.116 17.3346L17.3346 26.116Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1374 13.3334C12.3502 13.3334 13.3334 12.3502 13.3334 11.1374C13.3334 9.92459 12.3502 8.94141 11.1374 8.94141C9.92459 8.94141 8.94141 9.92459 8.94141 11.1374C8.94141 12.3502 9.92459 13.3334 11.1374 13.3334Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuywater);
export default __webpack_public_path__ + "static/media/buywater.04dbbe509a9016aa91b345a512b5c6e2.svg";
export { ForwardRef as ReactComponent };